import * as yup from 'yup';
import {
  CS_REVIEW_CONTENT_LIMIT,
  CS_REVIEW_CONTENT_MINIMUM,
} from '../../../../../constants/service/app/csReviewConstants';
import { countCharactersExcludeNewlines } from '../../../../../lib/utils/countCharacters';

export const errorMessages = {
  RATE_MIN: '평점은 최소 1점 이상이어야 합니다.',
  RATE_REQUIRED: '평점은 필수 입력사항입니다.',
  CONTENT_REQUIRED: '구매평은 필수값입니다.',
  REVIEW_CRITERIA_REQUIRED: '평가 항목은 필수값입니다.',
  PRODUCT_ID_REQUIRED: 'Product ID가 필요합니다!',
  USER_ID_REQUIRED: 'User ID가 필요합니다!',
  CONTENT_MINIMUM: `구매평은 최소 ${CS_REVIEW_CONTENT_MINIMUM}자 이상입니다.`,
  CONTENT_LIMIT: `최대 ${CS_REVIEW_CONTENT_LIMIT}자까지 입력할 수 있습니다.`,
  DUPLICATE_TYPE_MESSAGE: '중복된 평가항목 타입이 존재합니다.',
};

const validateRate = yup.number().min(1, errorMessages.RATE_MIN).required(errorMessages.RATE_REQUIRED);

const validateContent = yup
  .string()
  .test('content', errorMessages.CONTENT_LIMIT, (value = '') => {
    const length = countCharactersExcludeNewlines(value);
    return length <= CS_REVIEW_CONTENT_LIMIT;
  })
  .test('min', errorMessages.CONTENT_MINIMUM, (value = '') => {
    const length = countCharactersExcludeNewlines(value);
    return length >= CS_REVIEW_CONTENT_MINIMUM;
  })
  .required(errorMessages.CONTENT_REQUIRED);

const validateSelectedProduct = yup.object().shape({
  id: yup.number().required(errorMessages.PRODUCT_ID_REQUIRED),
});

const validateSelectedUser = yup.object().shape({
  id: yup.number().required(errorMessages.USER_ID_REQUIRED),
});

const validateReviewCriteria = yup.array().test('is-unique-type', errorMessages.DUPLICATE_TYPE_MESSAGE, (value) => {
  if (!value) return true;
  const typeSet = new Set(value.map((item) => item.type));
  return typeSet.size === value.length;
});

export const reviewCreateFormValidationSchema = yup.object({
  rate: validateRate,
  content: validateContent,
  selectedProduct: validateSelectedProduct,
  selectedUser: validateSelectedUser,
  reviewCriteria: validateReviewCriteria,
});

export const reviewUpdateFormValidationSchema = yup.object({
  rate: validateRate,
  content: validateContent,
  reviewCriteria: validateReviewCriteria,
});
